
import React, { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import module from '../css/moduleStyle.module.css';
import styles from '../css/sgnlOp.module.css';
import { SwItsEmergVehTotalProvider, HeaderData, BodyData, BodyListDetail } from 'pages/components/dashboard/SwItsGetEmergVehLog';
import { SrchButtons } from '../../components/button';
import { useNavigate } from 'react-router-dom';
import { useDashboard } from 'pages/components/DashboardContext';
import useNavigation from 'pages/components/UseNavigation';
import { useCctvContext } from '../sharedCamera';
import { IconLabelBackButtons } from '../../components/button';

import RtspPlayer from 'components/RtspPlayer'; // 경로 확인 필요
import { useTranslation } from 'react-i18next';
const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};

const getOneWeekAgoDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 7);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};

const formatDateForInput = (yyyymmdd) => {
  return `${yyyymmdd.slice(0, 4)}-${yyyymmdd.slice(4, 6)}-${yyyymmdd.slice(6, 8)}`;
};

export default function SignalOperationViewM() {
  const { mapMessages, clearLastMapMessage } = useDashboard();
  const { activeCctvs } = useCctvContext(); // 추가된 부분: CCTV 컨텍스트 사용

  const [startDate, setStartDate] = useState(getOneWeekAgoDate());
  const [endDate, setEndDate] = useState(getTodayDate());
  const stDateRef = useRef(null);
  const edDateRef = useRef(null);
  const [currentCctvs, setCurrentCctvs] = useState([]); // 추가된 부분: 현재 활성화된 CCTV 목록 상태

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'i18nextLng' && e.newValue && e.newValue !== i18n.language) {
        i18n.changeLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n]);

  // cctv 렌더링용 
  useEffect(() => {

    return () => console.log('SignalOperationViewM 언마운트됨');
  }, []);

  // activeCctvs 변화 감지 및 처리
  useEffect(() => {

    if (activeCctvs) {
      // 시간 제한을 10분으로 늘려서 테스트 (300000 -> 600000)
      const cctvArray = Object.values(activeCctvs).filter(cctv =>
        cctv && cctv.timestamp && (Date.now() - cctv.timestamp < 600000)
      );

      setCurrentCctvs(cctvArray);
    }
  }, [activeCctvs]);

  // 카메라 렌더링 함수
  const renderCctvVideos = () => {

    if (!currentCctvs || currentCctvs.length === 0) {
      return <div>활성화된 카메라가 없습니다</div>;
    }

    return currentCctvs.map(cctv => {

      // CCTV 정보 구성 - openCctvInfo에서 필요한 정보 추출
      const cctvInfo = cctv.info?.openCctvInfo;
      if (!cctvInfo) {
        return null;
      }
      const cameraId = cctvInfo.id || cctv.id;
      const url = `ws://localhost:8001/websocket/stream?id=${cameraId}&width=720&height=480&fps=15`;

      return (
        <div key={cctv.id} className="cctv-video-container">
          <h4>{cctvInfo.name || `카메라 ID: ${cctv.id}`}</h4>
          <RtspPlayer
            url={url}
            width="100%"
            height="auto"
            autoplay={true}
          // 기타 필요한 props
          />
        </div>
      );
    });
  };

  useNavigation(mapMessages);

  useEffect(() => {
    if (mapMessages.length > 0) {
      clearLastMapMessage();
    }
  }, [mapMessages]);

  // 추가된 부분: activeCctvs가 변경될 때마다 현재 활성화된 CCTV 목록 업데이트
  useEffect(() => {
    if (activeCctvs) {
      const cctvArray = Object.values(activeCctvs).filter(cctv =>
        cctv && cctv.timestamp && (Date.now() - cctv.timestamp < 5000) // 5분 이내 활성화된 CCTV
      );
      setCurrentCctvs(cctvArray);

      // CCTV가 새로 활성화되었을 때 알림 표시 (선택 사항)
      if (cctvArray.length > 0 && cctvArray.some(cctv => cctv.timestamp > Date.now() - 5000)) {
        // 여기에 필요한 알림 로직 추가 가능
      }
    }
  }, [activeCctvs]);

  const handleSearchClick = () => {
    const sDateStr = stDateRef.current.value;
    const eDateStr = edDateRef.current.value;

    const sDate = new Date(sDateStr);
    const eDate = new Date(eDateStr);

    // 1. 시작 날짜가 종료 날짜보다 이후일 경우
    if (sDate > eDate) {
      alert('시작 날짜는 종료 날짜보다 빠를 수 없습니다.');
      return;
    }

    // 2. 일주일 초과 조회 제한
    const diffDays = (eDate - sDate) / (1000 * 60 * 60 * 24);
    if (diffDays > 7) {
      alert('조회 기간은 최대 7일까지만 가능합니다.');
      return;
    }

    // 통과한 경우만 상태 업데이트
    setStartDate(sDateStr.replaceAll('-', ''));
    setEndDate(eDateStr.replaceAll('-', ''));
  };

  return (
    <SwItsEmergVehTotalProvider
      startDate={startDate}
      endDate={endDate}
    >
      <Box sx={{ height: '100%', width: '100%' }}>
        <div className="container">
          <div className={`${styles.SignalOperationView} contWrap L_lr`}>
            {/* 긴급차량 운행 현황 */}
            <div className={`${module.gap40} flx flx_col inner L_s`}>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-02)' }}>{t('EmergencyVehicleOperationStatus')}</h2>
                <IconLabelBackButtons sx={{ height: '80px' }}></IconLabelBackButtons>
              </div>
              <div className={`${module.gap20} flx flx_col`}>
                <h3 className={`${module.subTitle}`}>조회기간</h3>
                <div className={`${module.srchBox} flx a_center j_spc_btw`}>
                  <div className={`${module.date} flx a_center`}>
                    <input
                      type="date"
                      id="stDt"
                      ref={stDateRef}
                      defaultValue={formatDateForInput(startDate)}
                    />
                    <input
                      type="date"
                      id="edDt"
                      ref={edDateRef}
                      defaultValue={formatDateForInput(endDate)}
                    />
                  </div>
                  <SrchButtons onClick={handleSearchClick} />
                </div>
              </div>
              <div className={`${module.gap20} ${styles.resultBox__Sgnl} flx flx_col`}>
                <h3 className={`${module.subTitle}`}>조회결과</h3>
                <HeaderData />
                <ul className={`${styles.resultList} cst_scroll`}>
                  <BodyData />
                </ul>
              </div>
            </div>
            <BodyListDetail />
            {/* 기본정보, 신호제어 현황 */}
          </div>
        </div>
      </Box>
    </SwItsEmergVehTotalProvider>
  );
}
